import React, { useState } from 'react';

import { PrimaryButton, Text } from 'library';
import { client, track } from 'shared';

import usePublicSessionTracking from 'parent-portal/shared/PublicSessionTracking';
import { Checkbox } from '@material-ui/core';

import { SignUpDialog } from '../../public-application/SignUpDialog';

import Label from '../../../../reusableComponents/checkboxLabel';
import { useHistory } from 'react-router';
import AmbassadorAbout from '../welcome/AmbassadorAbout';
import AmbassadorPageLayout from '../AmbassadorPageLayout';
import GoldBadge from '../GoldBadge';
import Callout from '../Callout';

export default function AmbassadorSignUpPage() {
    const history = useHistory();

    const { trackSession, usePageLoadTracking } = usePublicSessionTracking('Ambassador Sign Up');
    usePageLoadTracking();

    const [loading, setLoading] = useState(false);
    const [errored, setErrored] = useState(false);
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const [userCreated, setUserCreated] = useState(false);

    const [isInOhio, setInOhio] = useState(false);

    async function signedUp(token: string) {
        setUserCreated(true);
        setLoading(true);
        try {
            await client(`api/ambassador/`);
        } catch (error) {
            setError();
        }
        setLoading(false);
    }

    function setError() {
        setErrored(true);
        track('Ambassadors: sign up errored');
    }

    function closeSignUp() {
        setShowSignUpModal(false);

        if (userCreated) goToNextPage();
    }

    function goToNextPage() {
        const destination = errored ? 'error' : 'welcome';
        const nextUrl = `/providers/ambassador/${destination}`;
        history.push(nextUrl);
        trackSession('NAVIGATE_FROM', `User sent to ${nextUrl}`);
    }

    async function signUpAsAmbassador() {
        setShowSignUpModal(true);
    }

    return (
        <>
            <AmbassadorPageLayout>
                <div style={{ marginBottom: 40 }}>
                    <Text variant="display" textStyle={{ marginBottom: 30 }}>
                        Tandem Ambassador Program
                    </Text>
                </div>
                <GoldBadge />
                <AmbassadorAbout />
                <Callout>
                    Confirm your location and click Sign Up to get started as an ambassador and start earning!
                </Callout>
                <Label
                    control={
                        <Checkbox
                            disabled={showSignUpModal || userCreated}
                            value={isInOhio}
                            onChange={() => setInOhio(!isInOhio)}
                        />
                    }
                    label={
                        <Text variant="body1">I am currently living in the Cincinnati, Columbus or Cleveland area</Text>
                    }
                />
                <Text variant="caption" textStyle={{ marginBottom: 40 }}>
                    Tandem is currently only accepting ambassadors in the Cincinnati, Columbus and Cleveland regions.
                </Text>
                <PrimaryButton
                    disabled={loading || !isInOhio || showSignUpModal || userCreated}
                    onClick={signUpAsAmbassador}
                >
                    Sign Up
                </PrimaryButton>
            </AmbassadorPageLayout>
            <SignUpDialog isOpen={showSignUpModal} onClose={closeSignUp} onUserCreated={signedUp} />
        </>
    );
}
